module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-error-8a7359a699e94a60c8a47e36e931ac6e.svg";